import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  open() {
    window.__openListingsSearch && window.__openListingsSearch()
  }
}
